import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGetCurrentVendor } from '../../hooks/global/User';

const SubMenu = ({ onSelect }) => {
    const { t } = useTranslation();
    const vendor = useGetCurrentVendor()
    return (<div className="d-flex flex-xl-column  flex-row">
        <button type="button" className="btn align-self-start d-xl-flex align-items-center text-start w-100 mb-3"
            onClick={() => onSelect("link")}
        >
            <div className="icon-circle text-white d-flex justify-content-center align-items-center mx-auto mx-xl-0">
                <i className="bi bi-link fs-5"></i>
            </div>
            <div className='submenu-text d-block d-xl-none text-center pb-2'>
                <strong><small>{t('admin.inv.linkMTitle')}</small></strong>
                <em>{t('admin.inv.linkMSub')}</em>
            </div>
            <div className="px-3 text-dark d-none d-xl-block">
                <strong>{t('admin.inv.linkMTitle')}</strong>
                <em>{t('admin.inv.linkMSub')}</em>
            </div>
        </button>
    
        <button type="button" className="btn align-self-start d-xl-flex align-items-center text-start w-100 mb-3"
            onClick={() => onSelect("email")}
        >
            <div className="icon-circle text-white d-flex justify-content-center align-items-center mx-auto mx-xl-0">
                <i className="bi bi-envelope-at fs-5"></i>
            </div>
            <div className='submenu-text d-block d-xl-none text-center pb-2'>
                <strong><small>{t('admin.inv.emailMTitle')}</small></strong>
                <em>{t('admin.inv.emailMSub')}</em>
            </div>
            <div className="px-3 text-dark d-none d-xl-block">
                <strong>{t('admin.inv.emailMTitle')}</strong>
                <em>{t('admin.inv.emailMSub')}</em>
            </div>
        </button>
    
        {vendor.services?.sms && (
            <button type="button" className="btn align-self-start d-xl-flex align-items-center text-start w-100 mb-3"
                onClick={() => onSelect("viberSms")}
            >
                <div className="icon-circle text-white d-flex justify-content-center align-items-center mx-auto mx-xl-0">
                    <i className="bi bi-chat fs-5"></i>
                </div>
                <div className='submenu-text d-block d-xl-none text-center pb-2'>
                    <strong><small>{t('admin.inv.smsMTitle')}</small></strong>
                    <em>{t('admin.inv.smsMSub')}</em>    
                </div>
                <div className="px-3 text-dark d-none d-xl-block">
                    <strong>{t('admin.inv.smsMTitle')}</strong>
                    <em>{t('admin.inv.smsMSub')}</em>
                </div>
            </button>
        )}
    
        <button type="button" className="btn align-self-start d-xl-flex align-items-center text-start w-100 mb-3"
            onClick={() => onSelect("qr")}>
            
            <div className="icon-circle text-white d-flex justify-content-center align-items-center mx-auto mx-xl-0">
                <i className="bi bi-qr-code fs-5"></i>
            </div>
            <div className='submenu-text d-block d-xl-none text-center pb-2'>
                <strong><small>{t('admin.inv.qrMTitle')}</small></strong>
                <em>{t('admin.inv.qrMSub')}</em>
            </div>
            <div className="px-3 text-dark d-none d-xl-block">
                <strong>{t('admin.inv.qrMTitle')}</strong>
                <em>{t('admin.inv.qrMSub')}</em>
            </div>
        </button>
    
        <button type="button" className="btn align-self-start d-xl-flex align-items-center text-start w-100 mb-3"
            onClick={() => onSelect("batch")}>

            <div className="icon-circle text-white d-flex justify-content-center align-items-center mx-auto mx-xl-0">
                <i className="bi bi-upload fs-5"></i>
            </div>
            <div className='submenu-text d-block d-xl-none text-center pb-2'>
                <strong><small>{t('admin.inv.massMTitle')}</small></strong>
                <em>{t('admin.inv.massMSub')}</em>
            </div>
            <div className="px-3 text-dark d-none d-xl-block">
                <strong>{t('admin.inv.massMTitle')}</strong>
                <em>{t('admin.inv.massMSub')}</em>
            </div>
        </button>
    
        <button type="button" className="btn align-self-start d-xl-flex align-items-center text-start w-100 mb-3"
            onClick={() => onSelect("list")}>
            <div className="icon-circle text-white d-flex justify-content-center align-items-center mx-auto mx-xl-0">
                <i className="bi bi-download fs-5"></i>
            </div>
            <div className='submenu-text d-block d-xl-none text-center pb-2'>
                <strong><small>{t('admin.inv.listMTitle')}</small></strong>
                <em>{t('admin.inv.listkMSub')}</em>
            </div>
            <div className="px-3 text-dark d-none d-xl-block">
                <strong>{t('admin.inv.listMTitle')}</strong>
                <em>{t('admin.inv.listkMSub')}</em>
            </div>
        </button>
    </div>
    
    );
};

export default SubMenu;